import Cookies from "js-cookie";
// import { config } from 'vue/types/umd'
// eslint-disable-next-line no-undef
const TokenKey = config.TokenKey
  ? // eslint-disable-next-line no-undef
    config.TokenKey
  : "RedCoral_loginuserkey_2018";
let loginUser = {
  userId: "10",
  ContactID: "7",
  enCode: null,
  account: "100002",
  password: null,
  secretkey: null,
  realName: "user2",
  nickName: null,
  headIcon: null,
  gender: null,
  mobile: null,
  telephone: null,
  email: null,
  oICQ: null,
  weChat: null,
  companyId: "1",
  companyName: "安徽医科大学第一附属医院",
  companyIds: null,
  departmentId: "100101",
  departmentName: "心血管内科",
  departmentIds: null,
  openId: null,
  roleIds: "1,11,12,13,14,2,3",
  postIds: "1,22,52",
  organizationId: "1",
  organizationName: "",
  companyDeptIds: "7,6,5,4,2,3,7,8,14,9,10,1,12,1,15,13,4,11",
  isSystem: false,
  ReceptionIds:
    "ed47b7ae48d0eb9c,ea067f3fb1182d6,ed16704de6992b2d,238c55e907cc4327",
  appId: "RedCoral_Web",
  logTime: "2018-11-12 14:53:01",
  iPAddress: "10.64.3.196",
  iPAddressName: "本地局域网",
  browser: "Chrome 70.0",
  loginMark: null,
  token:
    "7D4BD5E019B255A77A43055CF04C45CA20E62FD2E0A248B6D64CFF8CA1D9AF9337D45DDE064F45A7",
  imUrl: null
};

export function Person() {
  let currentUser = getToken();
  return {
    ID: currentUser.userId,
    NAME: currentUser.realName,
    DEPTID: currentUser.departmentId,
    DEPTNAME: currentUser.departmentName,
    COMPANYID: currentUser.companyId,
    COMPANYNAME: currentUser.companyName
  };
}
export function getToken() {
  let userCookie = Cookies.get(TokenKey); //获取cookies
  if (userCookie !== undefined) {
    let user = JSON.parse(userCookie);
    return user;
  } else {
    return loginUser;
  }
}
